import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ISelectOption } from "@miplatform/types";
import { createUUID, isEmpty } from "@miplatform/utils";

const getCancelReasonsUUID = createUUID();

export const useInspectionCancelModalViewModel = () => {
  const stateManager = useComponentState();
  const [cancelReasonOptions, setCancelReasonOptions] = useState<
    ISelectOption[]
  >([]);

  const loadCancelReasons = async () => {
    return stateManager.run(async () => {
      const response = await taskService.reasonGroups.getCancelReasons();
      if (response.status === HTTP_STATUSES.OK) {
        const { data } = response;

        if (isEmpty(data)) {
          setCancelReasonOptions([{ label: "None", value: "None" }]);
        } else {
          const options = data.map((cr: { reason: string }) => ({
            label: cr.reason,
            value: cr.reason,
          }));
          setCancelReasonOptions(options);
        }
      }

      return response;
    }, getCancelReasonsUUID);
  };

  return {
    cancelReasonOptions,
    loadCancelReasons,
    isLoading: stateManager.isBusy(),
  };
};
